<template>
    <svg version="1.1" class="staff" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 35 35" width="8px" height="8px" style="enable-background:new 0 0 35 35;" xml:space="preserve">
        <path fill="currentColor" d="M16.8,17.3c-3.6,0-6.6-2.9-6.6-6.6s2.9-6.6,6.6-6.6,6.6,3,6.6,6.6-3,6.6-6.6,6.6ZM21.9,30.9c-.7,0-1.5,0-2.3,0-1.8,0-3.7,0-5.5,0-.8,0-1.6,0-2.3,0-1.7,0-3.4,0-4.7-.4-1.8-.6-2.2-1.8-2.2-2.7,0-3.5,3.2-9,11.9-9s12.1,5.4,12.1,9-4.2,3.1-7,3.1Z"/>
    </svg>
</template>
